<div class="types-selector-container flex-center">
  <div class="switch-container">
    <label class="switch">
      <input type="checkbox" [(ngModel)]="typesSelected['trial']" (change)="onTypeChange()" />
      <span class="slider round"></span>
    </label>
  </div>
  <div class="fw-bold">Include Trial Events</div>
</div>
